import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { connect } from 'dva';
import { ConnectState, CollectionCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
import FTooltip from '@/components/FTooltip';
// import FResourceProperties from '@/components/FResourceProperties';
import { Pagination, Space } from 'antd';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import {
  // OnChange_step2_systemProperties_Action,
  ChangeAction,
  Step2_Fetch_CollectionItems_Action,
  OnClick_step2_submitBtn_Action,
  Step2_SaveDraft_Action,
} from '@/models/collectionCreatorPage';
import CollectionSetting from './CollectionSetting';
import * as AHooks from 'ahooks';
import FLoadingTip from '@/components/FLoadingTip';
import fMessage from '@/components/fMessage';
// import FCollectionItems from '@/components/FCollectionItems';
import fSelectResourcesAsCollectionItems from '@/components/fSelectResourcesAsCollectionItems';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
// import CollectionSetting_Sort from '@/pages/resource/collectionCreator/Step2/CollectionSetting_Sort';
import FContractHandleDrawer from '@/components/FContractHandleDrawer';
import FAddResourcesHandleAuth from '@/components/FAddResourcesHandleAuth';
import FIcons from '@/components/FIcons';
import FCollectionItems2 from '@/components/FCollectionItems2';
// import { Version_Fetch_CollectionItems_Action } from '@/models/collectionManager';
import SortOrderModal from '@/pages/resource/collectionSidebar/versionInfo/$id/SortOrderModal';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';

interface Step2Props {
  dispatch: Dispatch;
  collectionCreatorPage: CollectionCreatorPageModelState;
}

function Step2({ dispatch, collectionCreatorPage }: Step2Props) {
  const ref_ItemsTitle = React.useRef<any>(null);

  const [$showMore, set$ShowMore, get$ShowMore] = FUtil.Hook.useGetState<boolean>(false);
  const [
    $collectionSettingExpansion,
    set$collectionSettingExpansion,
    get$collectionSettingExpansion,
  ] = FUtil.Hook.useGetState<'style' | 'sort' | ''>('');
  const [$checkedItemIDs, set$checkedItemIDs, get$checkedItemIDs] = FUtil.Hook.useGetState<
    string[]
  >([]);

  const [$authProcessorShow, set$authProcessorShow, get$authProcessorShow] =
    FUtil.Hook.useGetState<number>(0);
  const [$licensorId, set$licensorId, get$licensorId] = FUtil.Hook.useGetState<string>('');
  const [$itemId, set$itemId, get$itemId] = FUtil.Hook.useGetState<string>('');

  const [$resourceIDs, set$resourceIDs, get$resourceIDs] = FUtil.Hook.useGetState<string[]>([]);

  const [$sortOrderModalShow, set$sortOrderModalShow, get$sortOrderModalShow] =
    FUtil.Hook.useGetState<boolean>(false);

  const { run: keywordsRun } = AHooks.useDebounceFn(
    () => {
      dispatch<Step2_Fetch_CollectionItems_Action>({
        type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
      });
    },
    {
      wait: 300,
    },
  );

  const { run: run_saveDraft } = AHooks.useDebounceFn(
    () => {
      dispatch<Step2_SaveDraft_Action>({
        type: 'collectionCreatorPage/step2_SaveDraft',
      });
    },
    {
      wait: 300,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      const itemIDs: string[] = get$checkedItemIDs().filter((id) => {
        return collectionCreatorPage.step2_resources.some((ci) => {
          return ci.itemID === id;
        });
      });
      set$checkedItemIDs(itemIDs);
    },
    [collectionCreatorPage.step2_resources],
    {
      wait: 300,
    },
  );

  async function onChange_needSaveDraft(payload: Partial<CollectionCreatorPageModelState>) {
    await dispatch<ChangeAction>({
      type: 'collectionCreatorPage/change',
      payload: {
        ...payload,
        step2_otherChanged: true,
      },
    });
    run_saveDraft();
  }

  async function onChange_needSaveDraft_collectionItems(
    payload: Partial<CollectionCreatorPageModelState>,
  ) {
    await dispatch<ChangeAction>({
      type: 'collectionCreatorPage/change',
      payload: {
        ...payload,
        step2_collectionItemsChanged: true,
      },
    });
    run_saveDraft();
  }

  async function onChangePage(page: number, pageSize: number) {
    const version_resources_pageCurrent = collectionCreatorPage.step2_resources_pageCurrent;
    await dispatch<ChangeAction>({
      type: 'collectionCreatorPage/change',
      payload: {
        step2_resources_pageCurrent: page,
        step2_resources_pageSize: pageSize,
      },
    });
    await dispatch<Step2_Fetch_CollectionItems_Action>({
      type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
    });
    if (page !== version_resources_pageCurrent) {
      ref_ItemsTitle.current?.scrollIntoView({
        behavior: 'smooth',
        // block: 'end',
        // inline: 'nearest',
      });
    }
  }

  return (
    <div>
      <div style={{ height: 40 }} />
      <div className={styles.block}>
        <div ref={ref_ItemsTitle} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {/*<FComponentsLib.FContentText text={'单品资源管理'} type={'highlight'} />*/}
          <FComponentsLib.FContentText text={FI18n.i18nNext.t('cqr_itemmgmt')} type={'highlight'} />

          {collectionCreatorPage.step2_resources.length > 0 && (
            <FComponentsLib.FTextBtn
              style={{
                fontSize: 12,
                display: 'flex',
                alignItems: 'center',
                gap: 5,
              }}
              type='primary'
              onClick={async () => {
                fSetHotspotTooltipVisible('collectionCreator.step2.addResourceButton', {
                  value: false,
                  effectiveImmediately: true,
                  onlyNullish: false,
                });
                // set$showDrawer(true);
                // onClick_addItems();

                const result: string[] | null = await fSelectResourcesAsCollectionItems({
                  collectionID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
                });
                if (!result || result.length === 0) {
                  return;
                }

                set$resourceIDs(result);
              }}
            >
              <FIcons.FAdd style={{ fontSize: 14 }} />
              <span>{FI18n.i18nNext.t('cqr_itemmgmt_empty_btn_additem')}</span>
            </FComponentsLib.FTextBtn>
          )}
        </div>

        {collectionCreatorPage.step2_resources_state !== 'noData' && (
          <>
            <div style={{ height: 20 }} />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <FComponentsLib.FContentText
                  // text={`单品数量 ${collectionCreatorPage.step2_resources.length}`}
                  text={FI18n.i18nNext.t('cqr_itemmgmt_lable_itemqty', {
                    // itemCount: collectionCreatorPage.step2_resources_totalCount,
                    ItemCount: collectionCreatorPage.step2_resources_totalCount,
                  })}
                  type={'additional2'}
                  style={{ color: '#222' }}
                />
                <div style={{ position: 'relative' }}>
                  <FComponentsLib.FTextBtn
                    type={'primary'}
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      set$collectionSettingExpansion(
                        get$collectionSettingExpansion() === 'style' ? '' : 'style',
                      );
                    }}
                  >
                    展示样式设置
                    {/*{FI18n.i18nNext.t('cqr_itemmgmt_viewoptions')}*/}
                  </FComponentsLib.FTextBtn>
                  {$collectionSettingExpansion === 'style' && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 35,
                        left: '50%',
                        marginLeft: -15,
                        width: 0,
                        height: 0,
                        borderLeft: '15px solid transparent',
                        borderRight: '15px solid transparent',
                        borderBottom: '15px solid #F7F7F7',
                      }}
                    />
                  )}
                </div>
                <div style={{ position: 'relative' }}>
                  <FComponentsLib.FTextBtn
                    type={'primary'}
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      // set$collectionSettingExpansion(get$collectionSettingExpansion() === 'sort' ? '' : 'sort');
                      set$sortOrderModalShow(true);
                    }}
                  >
                    调整排序
                  </FComponentsLib.FTextBtn>
                  {$collectionSettingExpansion === 'sort' && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 35,
                        left: '50%',
                        marginLeft: -15,
                        width: 0,
                        height: 0,
                        borderLeft: '15px solid transparent',
                        borderRight: '15px solid transparent',
                        borderBottom: '15px solid #F7F7F7',
                      }}
                    />
                  )}
                </div>
              </div>

              <FComponentsLib.FInput.FSearch
                value={collectionCreatorPage.step2_resourceKeywords}
                onChange={(value) => {
                  dispatch<ChangeAction>({
                    type: 'collectionCreatorPage/change',
                    payload: {
                      step2_resourceKeywords: value,
                    },
                  });

                  keywordsRun();
                }}
                placeholder={FI18n.i18nNext.t('cqr_itemmgmt_search_hint')}
              />
            </div>
            <div style={{ height: 10 }} />

            {$collectionSettingExpansion === 'style' && (
              <>
                <div style={{ height: 10 }} />
                <CollectionSetting
                  onClose={() => {
                    set$collectionSettingExpansion('');
                  }}
                  setting={collectionCreatorPage.step2_collectionItemsSetting}
                  onChange={async (value) => {
                    await onChange_needSaveDraft({
                      step2_collectionItemsSetting: value,
                    });
                  }}
                  onChangeSort={async (sort) => {
                    await dispatch<Step2_Fetch_CollectionItems_Action>({
                      type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
                    });
                  }}
                  onChangeView={async (view) => {
                    await dispatch<ChangeAction>({
                      type: 'collectionCreatorPage/change',
                      payload: {
                        step2_resources_pageCurrent: 1,
                        step2_resources_pageSize: view === 'collection_view_card' ? 6 : 10,
                      },
                    });

                    await dispatch<Step2_Fetch_CollectionItems_Action>({
                      type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
                    });
                  }}
                />
              </>
            )}

            <div style={{ height: 10 }} />
            {collectionCreatorPage.step2_resources_state === 'noSearchResult' && (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <FComponentsLib.FContentText text={'暂无搜索结果'} type={'additional2'} />
              </div>
            )}

            {collectionCreatorPage.step2_resources_state === 'loading' && (
              <FLoadingTip height={200} />
            )}

            {collectionCreatorPage.step2_resources_state === 'loaded' && (
              <FCollectionItems2
                showView={
                  collectionCreatorPage.step2_collectionItemsSetting.collection_view ===
                  'collection_view_list'
                    ? 'list'
                    : 'card'
                }
                showCheckbox={'hide'}
                checkedItemIDs={$checkedItemIDs}
                showCover={
                  collectionCreatorPage.step2_collectionItemsSetting
                    .collection_item_image_display === 'collection_item_image_display_show'
                    ? 'show'
                    : 'hide'
                }
                showNumber={
                  collectionCreatorPage.step2_collectionItemsSetting.collection_item_no_display ===
                  'collection_item_no_display_show'
                    ? 'show'
                    : 'hide'
                }
                showTitle={
                  collectionCreatorPage.step2_collectionItemsSetting.collection_item_title ===
                  'collection_item_title_rtitle'
                    ? 'title'
                    : collectionCreatorPage.step2_collectionItemsSetting.collection_item_title ===
                      'collection_item_title_sn'
                    ? 'serial'
                    : collectionCreatorPage.step2_collectionItemsSetting.collection_item_title ===
                      'collection_item_title_custom'
                    ? 'custom'
                    : 'hide'
                }
                showIntroduction={
                  collectionCreatorPage.step2_collectionItemsSetting
                    .collection_item_descr_display === 'collection_item_descr_display_show'
                    ? 'show'
                    : 'hide'
                }
                resources={collectionCreatorPage.step2_resources}
                onClick={(itemID, resourceID) => {
                  set$authProcessorShow(get$authProcessorShow() + 1);
                  set$licensorId(resourceID);
                  set$itemId(itemID);
                }}
                onChangeChecked={async (itemID, checked) => {
                  if (checked) {
                    set$checkedItemIDs([...get$checkedItemIDs(), itemID]);
                  } else {
                    set$checkedItemIDs(
                      get$checkedItemIDs().filter((i) => {
                        return i !== itemID;
                      }),
                    );
                  }
                }}
                onChangeCustomTitle={async (itemID, title) => {
                  await FServiceAPI.Resource.updateCollectionItemsInfo_Draft({
                    resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
                    data: [
                      {
                        itemId: itemID,
                        itemTitle: title,
                      },
                    ],
                  });
                  await onChange_needSaveDraft_collectionItems({});
                  await dispatch<ChangeAction>({
                    type: 'collectionCreatorPage/change',
                    payload: {
                      step2_resources: collectionCreatorPage.step2_resources.map((vc) => {
                        if (vc.itemID !== itemID) {
                          return vc;
                        }
                        return {
                          ...vc,
                          itemTitle: title,
                        };
                      }),
                    },
                  });
                }}
                onClickDelete={async (itemID) => {
                  const { data } = await FServiceAPI.Resource.deleteCollectionItems_Draft({
                    resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
                    removeCollectionItemIds: [itemID],
                  });
                  await dispatch<ChangeAction>({
                    type: 'collectionCreatorPage/change',
                    payload: {
                      step2_resources_pageCurrent: Math.min(
                        Math.floor(
                          (collectionCreatorPage.step2_resources_totalCount - 1) /
                            collectionCreatorPage.step2_resources_pageSize,
                        ) + 1,
                        collectionCreatorPage.step2_resources_pageCurrent,
                      ),
                    },
                  });
                  await dispatch<Step2_Fetch_CollectionItems_Action>({
                    type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
                  });
                  await onChange_needSaveDraft_collectionItems({});
                }}
              />
            )}

            {((collectionCreatorPage.step2_collectionItemsSetting.collection_view ===
              'collection_view_list' &&
              collectionCreatorPage.step2_resources_totalCount > 10) ||
              (collectionCreatorPage.step2_collectionItemsSetting.collection_view ===
                'collection_view_card' &&
                collectionCreatorPage.step2_resources_totalCount > 6)) && (
              <>
                <div style={{ height: 20 }} />

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Pagination
                    showTitle={false}
                    locale={{
                      // items_per_page: '条/页',
                      items_per_page: FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_perpage'),
                      // jump_to: '前往',
                      jump_to: FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_currentpage'),
                      // page: '页',
                      page: ' ',
                    }}
                    size='small'
                    showSizeChanger
                    showQuickJumper
                    current={collectionCreatorPage.step2_resources_pageCurrent}
                    pageSize={collectionCreatorPage.step2_resources_pageSize}
                    total={collectionCreatorPage.step2_resources_totalCount}
                    onChange={onChangePage}
                    showTotal={(total) => {
                      // return `共${total}条`;
                      return FI18n.i18nNext.t('cqr_itemmgmt_list_pagenation_total', {
                        PageCount: total,
                      });
                    }}
                    pageSizeOptions={
                      collectionCreatorPage.step2_collectionItemsSetting.collection_view ===
                      'collection_view_card'
                        ? [6, 12, 18, 24, 30]
                        : [10, 20, 30, 40, 50]
                    }
                  />
                </div>
              </>
            )}
          </>
        )}

        {collectionCreatorPage.step2_resources_state === 'noData' && (
          <>
            <div style={{ height: 10 }} />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <FComponentsLib.FContentText
                text={FI18n.i18nNext.t('cqr_itemmgmt_empty_msg')}
                type={'additional2'}
              />
              <div style={{ height: 20 }} />
              <FHotspotTooltip
                id={'collectionCreator.step2.addResourceButton'}
                style={{ left: 32, bottom: -38 }}
                zIndex={100}
                text={FI18n.i18nNext.t('hotpots_cqr_additem')}
                onOpenChange={(o) => {
                  if (o) {
                    fSetHotspotTooltipVisible('collectionCreator.step2.addResourceButton', {
                      value: false,
                      effectiveImmediately: false,
                      onlyNullish: false,
                    });
                  }
                }}
              >
                <FComponentsLib.FRectBtn
                  onClick={async () => {
                    fSetHotspotTooltipVisible('collectionCreator.step2.addResourceButton', {
                      value: false,
                      effectiveImmediately: true,
                      onlyNullish: false,
                    });
                    const result: string[] | null = await fSelectResourcesAsCollectionItems({
                      collectionID:
                        collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
                    });
                    if (!result || result.length === 0) {
                      return;
                    }

                    set$resourceIDs(result);
                  }}
                >
                  {FI18n.i18nNext.t('cqr_itemmgmt_empty_btn_additem')}
                </FComponentsLib.FRectBtn>
              </FHotspotTooltip>
            </div>
            <div style={{ height: 20 }} />
          </>
        )}
      </div>

      <div style={{ height: 5 }} />

      <div className={styles.block}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <FComponentsLib.FContentText
            // text={'基础属性'}
            text={FI18n.i18nNext.t('resourceinfo_title')}
            type={'highlight'}
          />

          {collectionCreatorPage.step2_customProperties.length < 30 && (
            <FTooltip title={FI18n.i18nNext.t('resourceinfo_add_btn_info')}>
              <div>
                <FComponentsLib.FTextBtn
                  style={{
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                  }}
                  type='primary'
                  onClick={async () => {
                    const dataSource: {
                      key: string;
                      name: string;
                      // value: string;
                      description: string;
                    } | null = await fResourcePropertyEditor3({
                      disabledKeys: [
                        ...collectionCreatorPage.step2_systemProperties.map<string>((sp) => sp.key),
                        ...collectionCreatorPage.step2_customProperties.map<string>((bp) => bp.key),
                        ...collectionCreatorPage.step2_customConfigurations.map<string>(
                          (pp) => pp.key,
                        ),
                      ],
                      disabledNames: [
                        ...collectionCreatorPage.step2_systemProperties.map<string>(
                          (sp) => sp.name,
                        ),
                        ...collectionCreatorPage.step2_customProperties.map<string>(
                          (bp) => bp.name,
                        ),
                        ...collectionCreatorPage.step2_customConfigurations.map<string>(
                          (pp) => pp.name,
                        ),
                      ],
                    });
                    // console.log(dataSource, 'dataSource9iojskldjflksdjflk');
                    if (!dataSource) {
                      return;
                    }

                    const finalDate: CollectionCreatorPageModelState['step2_customProperties'] = [
                      ...collectionCreatorPage.step2_customProperties,
                      {
                        ...dataSource,
                        value: '',
                      },
                    ];

                    await onChange_needSaveDraft({
                      step2_customProperties: finalDate,
                    });
                  }}
                >
                  <FIcons.FProperty style={{ fontSize: 14 }} />
                  <span>补充属性</span>
                </FComponentsLib.FTextBtn>
              </div>
            </FTooltip>
          )}
        </div>

        {collectionCreatorPage.step2_systemProperties.length === 0 &&
          collectionCreatorPage.step2_customProperties.length === 0 && (
            <>
              <div style={{ height: 10 }} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FComponentsLib.FContentText
                  // text={'暂无数据'}
                  text={FI18n.i18nNext.t('resourceinfo_empty_msg')}
                  type={'additional2'}
                  style={{ maxWidth: 600, textAlign: 'center' }}
                />
              </div>
              <div style={{ height: 20 }} />
            </>
          )}

        {!(
          collectionCreatorPage.step2_systemProperties.length === 0 &&
          collectionCreatorPage.step2_customProperties.length === 0
        ) && (
          <>
            <div style={{ height: 20 }} />
            <FAttrsAndConfigs
              dateSource={[
                ...collectionCreatorPage.step2_systemProperties.map<IAttrsAndConfigsItem>((sp) => {
                  return {
                    key: sp.key,
                    value: sp.value,
                    name: sp.name,
                    description: sp.description,
                    configs: {
                      item_Deletable: false,
                      key_Editable: false,
                      name_Editable: false,
                      description_Editable: false,
                      value_Editable: (sp.type === 'additional' && sp.valueConfig) || false,
                    },
                  };
                }),
                ...collectionCreatorPage.step2_customProperties.map<IAttrsAndConfigsItem>((cp) => {
                  return {
                    key: cp.key,
                    value: cp.value,
                    name: cp.name,
                    description: cp.description,
                    configs: {
                      item_Deletable: true,
                      key_Editable: true,
                      name_Editable: true,
                      description_Editable: true,
                      value_Editable: {
                        text: {
                          nullable: true,
                          minLength: 0,
                          maxLength: 140,
                        },
                      },
                    },
                  };
                }),
              ]}
              onChangeItem={async (oldData, newData, index) => {
                if (index < collectionCreatorPage.step2_systemProperties.length) {
                  const newDateSource = [...collectionCreatorPage.step2_systemProperties];
                  newDateSource[index] = {
                    key: newData.key,
                    name: newData.name,
                    value: newData.value,
                    description: newData.description,
                    type: collectionCreatorPage.step2_systemProperties[index].type,
                    valueConfig: collectionCreatorPage.step2_systemProperties[index].valueConfig,
                  };
                  await onChange_needSaveDraft({
                    step2_systemProperties: newDateSource,
                  });
                } else {
                  const newDateSource = [...collectionCreatorPage.step2_customProperties];
                  newDateSource[index - collectionCreatorPage.step2_systemProperties.length] = {
                    key: newData.key,
                    name: newData.name,
                    value: newData.value,
                    description: newData.description,
                  };
                  await onChange_needSaveDraft({
                    step2_customProperties: newDateSource,
                  });
                }
              }}
              onDeleteItem={async (value) => {
                const finalDate: CollectionCreatorPageModelState['step2_customProperties'] =
                  collectionCreatorPage.step2_customProperties.filter((v, i) => {
                    return v.key !== value.key && v.name !== value.name;
                  });
                await onChange_needSaveDraft({
                  step2_customProperties: finalDate,
                });
              }}
              disabledKeys={[
                ...collectionCreatorPage.step2_systemProperties.map<string>((rp) => rp.key),
                ...collectionCreatorPage.step2_customProperties.map<string>((cp) => cp.key),
                ...collectionCreatorPage.step2_customConfigurations.map<string>((cc) => cc.key),
              ]}
              disabledNames={[
                ...collectionCreatorPage.step2_systemProperties.map<string>((rp) => rp.name),
                ...collectionCreatorPage.step2_customProperties.map<string>((cp) => cp.name),
                ...collectionCreatorPage.step2_customConfigurations.map<string>((cc) => cc.name),
              ]}
            />
          </>
        )}
      </div>

      <div style={{ height: 15 }} />

      {$showMore ? (
        <FComponentsLib.FTextBtn
          style={{ fontSize: 12 }}
          type={'primary'}
          onClick={() => {
            set$ShowMore(false);
          }}
        >
          {FI18n.i18nNext.t('create_new_version_btn_showless')}
        </FComponentsLib.FTextBtn>
      ) : (
        <Space size={10}>
          {/*{FI18n.i18nNext.t('create_new_version_btn_moresetting')}*/}
          <FComponentsLib.FTextBtn
            style={{ fontSize: 12 }}
            type={'primary'}
            onClick={() => {
              set$ShowMore(true);
            }}
          >
            更多设置
          </FComponentsLib.FTextBtn>
          {/*<FComponentsLib.FContentText text={'可以为资源文件添加可选配置，或进行依赖资源的声明'} type={'additional2'} />*/}
          <FComponentsLib.FContentText
            text={FI18n.i18nNext.t('create_new_version_btn_moresetting_help')}
            type={'additional2'}
          />
        </Space>
      )}

      <div style={{ display: $showMore ? 'block' : 'none' }}>
        <div style={{ height: 10 }} />

        {collectionCreatorPage.step2_resourceTypeConfig.isSupportOptionalConfig && (
          <>
            <div className={styles.block}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('resourceoptions_title')}
                  type={'highlight'}
                />
                {collectionCreatorPage.step2_customConfigurations.length < 30 && (
                  // <FTooltip title={FI18n.i18nNext.t('resourceinfo_add_btn_info')}>
                  <FTooltip title={FI18n.i18nNext.t('info_versionoptions')}>
                    <div>
                      <FComponentsLib.FTextBtn
                        style={{
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 5,
                        }}
                        type='primary'
                        onClick={async () => {
                          const dataSource: {
                            key: string;
                            name: string;
                            type: 'input' | 'select';
                            input: string;
                            select: string[];
                            description: string;
                          } | null = await fResourceOptionEditor({
                            disabledKeys: [
                              ...collectionCreatorPage.step2_systemProperties.map<string>(
                                (sp) => sp.key,
                              ),
                              ...collectionCreatorPage.step2_customProperties.map<string>(
                                (bp) => bp.key,
                              ),
                              ...collectionCreatorPage.step2_customConfigurations.map<string>(
                                (pp) => pp.key,
                              ),
                            ],
                            disabledNames: [
                              ...collectionCreatorPage.step2_systemProperties.map<string>(
                                (sp) => sp.name,
                              ),
                              ...collectionCreatorPage.step2_customProperties.map<string>(
                                (bp) => bp.name,
                              ),
                              ...collectionCreatorPage.step2_customConfigurations.map<string>(
                                (pp) => pp.name,
                              ),
                            ],
                          });

                          if (!dataSource) {
                            return;
                          }

                          const finalData: CollectionCreatorPageModelState['step2_customConfigurations'] =
                            [...collectionCreatorPage.step2_customConfigurations, dataSource];

                          await onChange_needSaveDraft({
                            step2_customConfigurations: finalData,
                          });
                        }}
                      >
                        <FIcons.FConfiguration style={{ fontSize: 14 }} />
                        <span>{FI18n.i18nNext.t('resourceoptions_add_btn')}</span>
                      </FComponentsLib.FTextBtn>
                    </div>
                  </FTooltip>
                )}
              </div>

              {collectionCreatorPage.step2_customConfigurations.length === 0 && (
                <>
                  <div style={{ height: 10 }} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {/*<span>{FI18n.i18nNext.t('resourceoptions_list_empty')}</span>*/}
                    <FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('resourceoptions_list_empty')}
                      type={'additional2'}
                    />
                  </div>
                  <div style={{ height: 20 }} />
                </>
              )}

              {collectionCreatorPage.step2_customConfigurations.length > 0 && (
                <>
                  <div style={{ height: 20 }} />
                  <FResourceOptions
                    theme={'dark'}
                    // dataSource={resourceVersionCreatorPage.customOptionsData}
                    dataSource={collectionCreatorPage.step2_customConfigurations}
                    onEdit={async (value) => {
                      const index: number =
                        collectionCreatorPage.step2_customConfigurations.findIndex((p) => {
                          return p === value;
                        });

                      const dataSource: {
                        key: string;
                        name: string;
                        type: 'input' | 'select';
                        input: string;
                        select: string[];
                        description: string;
                      } | null = await fResourceOptionEditor({
                        disabledKeys: [
                          ...collectionCreatorPage.step2_systemProperties.map<string>(
                            (sp) => sp.key,
                          ),
                          ...collectionCreatorPage.step2_customProperties.map<string>(
                            (bp) => bp.key,
                          ),
                          ...collectionCreatorPage.step2_customConfigurations.map<string>(
                            (pp) => pp.key,
                          ),
                        ],
                        disabledNames: [
                          ...collectionCreatorPage.step2_systemProperties.map<string>(
                            (sp) => sp.name,
                          ),
                          ...collectionCreatorPage.step2_customProperties.map<string>(
                            (bp) => bp.name,
                          ),
                          ...collectionCreatorPage.step2_customConfigurations.map<string>(
                            (pp) => pp.name,
                          ),
                        ],
                        defaultData: value,
                      });

                      if (!dataSource) {
                        return;
                      }

                      const finalData: CollectionCreatorPageModelState['step2_customConfigurations'] =
                        collectionCreatorPage.step2_customConfigurations.map((a, b) => {
                          if (b !== index) {
                            return a;
                          }
                          return dataSource;
                        });

                      await onChange_needSaveDraft({
                        step2_customConfigurations: finalData,
                      });
                    }}
                    onDelete={async (value) => {
                      const finalData: CollectionCreatorPageModelState['step2_customConfigurations'] =
                        collectionCreatorPage.step2_customConfigurations.filter((a) => {
                          return a.key !== value.key && a.name !== value.name;
                        });

                      await onChange_needSaveDraft({
                        step2_customConfigurations: finalData,
                      });
                    }}
                  />
                </>
              )}
            </div>

            <div style={{ height: 5 }} />
          </>
        )}

        <div className={styles.block}>
          {collectionCreatorPage.step1_createdResourceInfo &&
            collectionCreatorPage.step2_authReload > 0 && (
              <FMicroAPP_Authorization
                // reload={collectionCreatorPage.step2_authReload}
                licenseeId={collectionCreatorPage.step1_createdResourceInfo.resourceID}
                mainAppType={'resourceInVersionUpdate'}
                // mainAppType={'resourceInfoPool'}
                depList={collectionCreatorPage.step2_directDependencies}
                upcastList={collectionCreatorPage.step2_baseUpcastResources}
                mount={() => {}}
                update={async (data) => {
                  await onChange_needSaveDraft({
                    step2_directDependencies: data.directDependencies || [],
                    // step2_resolveResources: data.resolveResources,
                    step2_baseUpcastResources: data.baseUpcastResources || [],
                    step2_authExcludedItems: data.authExcludedItems || [],
                  });
                }}
              />
            )}
        </div>
      </div>

      <div style={{ height: 30 }} />

      <div className={styles.btn}>
        {collectionCreatorPage.step2_draftSaveTime !== '' &&
          !collectionCreatorPage.step2_draftSaving && (
            <FComponentsLib.FContentText
              // text={`已保存 ${collectionCreatorPage.step2_draftSaveTime}`}
              text={FI18n.i18nNext.t('edit_collection_itemmgnt_savedraft_state_saved', {
                LastEditTime: collectionCreatorPage.step2_draftSaveTime,
              })}
              type={'additional2'}
            />
          )}

        {collectionCreatorPage.step2_draftSaving && (
          <FComponentsLib.FContentText
            text={FI18n.i18nNext.t('edit_collection_itemmgnt_savedraft_state_saving')}
            type={'additional2'}
          />
        )}

        <FComponentsLib.FTextBtn
          type={'default'}
          onClick={() => {
            // history.push(FUtil.LinkTo.resourceVersionInfo({
            //   resourceID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
            // }));
            dispatch<Step2_SaveDraft_Action>({
              type: 'collectionCreatorPage/step2_SaveDraft',
            });
          }}
        >
          {FI18n.i18nNext.t('save_as_draft')}
        </FComponentsLib.FTextBtn>

        <FHotspotTooltip
          id={'collectionCreator.step2.submitButton'}
          style={{ left: 26, bottom: -38 }}
          zIndex={100}
          text={FI18n.i18nNext.t('hotpots_cqr_additem_done')}
          onOpenChange={(o) => {
            if (o) {
              fSetHotspotTooltipVisible('collectionCreator.step2.submitButton', {
                value: false,
                effectiveImmediately: false,
                onlyNullish: false,
              });
            }
          }}
        >
          <FComponentsLib.FRectBtn
            disabled={!collectionCreatorPage.step2_isCompleteAuthorization}
            type={'primary'}
            onClick={async () => {
              await dispatch<OnClick_step2_submitBtn_Action>({
                type: 'collectionCreatorPage/onClick_step2_submitBtn',
              });

              await dispatch<ChangeAction>({
                type: 'collectionCreatorPage/change',
                payload: {
                  step2_collectionItemsChanged: false,
                  step2_otherChanged: false,
                },
              });

              // run_saveDraft();
              // await onChange_needSaveDraft_collectionItems({});

              await dispatch<Step2_SaveDraft_Action>({
                type: 'collectionCreatorPage/step2_SaveDraft',
              });

              await dispatch<ChangeAction>({
                type: 'collectionCreatorPage/change',
                payload: {
                  step: 3,
                },
              });
            }}
          >
            {FI18n.i18nNext.t('cqr_itemmgmt_btn_submit')}
          </FComponentsLib.FRectBtn>
        </FHotspotTooltip>
      </div>

      <div style={{ height: 100 }} />
      {collectionCreatorPage.step1_createdResourceInfo &&
        collectionCreatorPage.step1_createdResourceInfo.resourceID !== '' &&
        $resourceIDs.length === 0 && (
          <FContractHandleDrawer
            open={$authProcessorShow}
            licensorId={$licensorId}
            itemId={$itemId}
            licenseeId={collectionCreatorPage.step1_createdResourceInfo.resourceID}
            onUpdate={async (options) => {
              // const {
              //   ret,
              //   errCode,
              //   msg,
              //   data: data_result,
              // } = await FServiceAPI.Resource.updateCollectionItemAuthorization_Draft(
              //   {
              //     resourceId:
              //       collectionCreatorPage.step1_createdResourceInfo
              //         ?.resourceID || '',
              //     // @ts-ignore
              //     optionalResolveResources: options.resolveResources.filter(
              //       (rr) => {
              //         return rr.contracts.length > 0;
              //       },
              //     ),
              //   },
              // );

              const itemData: {
                itemId: string;
                authExcludedItems: {
                  resourceId: string;
                  excludedType: 'contractId' | 'policyId';
                  excludedValue: string;
                }[];
              } = {
                itemId: get$itemId(),
                authExcludedItems: options.authExcludedItems
                  .map((item) => {
                    return item.contracts.map((contract) => {
                      return {
                        resourceId: item.resourceID,
                        excludedType: 'contractId' as const,
                        excludedValue: contract.contractID,
                      };
                    });
                  })
                  .flat(),
              };

              const { ret, errCode, msg, data } = await FServiceAPI.Resource.setItemsTitle({
                resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
                data: [itemData],
              });

              if (ret !== 0 || errCode !== 0) {
                fMessage(msg, 'error');
                return;
              }

              await dispatch<Step2_Fetch_CollectionItems_Action>({
                type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
              });

              await onChange_needSaveDraft_collectionItems({});
            }}
            onClose={() => {
              set$authProcessorShow(0);
              set$licensorId('');
              set$itemId('');
            }}
          />
        )}

      {collectionCreatorPage.step1_createdResourceInfo &&
        collectionCreatorPage.step1_createdResourceInfo.resourceID !== '' &&
        $resourceIDs.length > 0 && (
          <FAddResourcesHandleAuth
            resourceIDs={$resourceIDs}
            collectionID={collectionCreatorPage.step1_createdResourceInfo.resourceID}
            isPublish={false}
            onCancel={() => {
              set$resourceIDs([]);
            }}
            onOk={async () => {
              set$resourceIDs([]);

              // await dispatch<Version_Fetch_CollectionItems_Action>({
              //   type: 'collectionManager/version_Fetch_CollectionItems',
              // });
              await dispatch<Step2_Fetch_CollectionItems_Action>({
                type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
              });

              await onChange_needSaveDraft_collectionItems({});
            }}
            onBack={async () => {
              set$resourceIDs([]);
              // const collectionID = await fCollectionSelector();
              // if (!collectionID) {
              //   return;
              // }
              // set$collectionID(collectionID);

              const result: string[] | null = await fSelectResourcesAsCollectionItems({
                collectionID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
              });
              if (!result || result.length === 0) {
                return;
              }

              set$resourceIDs(result);
            }}
            onError={() => {
              set$resourceIDs([]);
            }}
          />
        )}

      <SortOrderModal
        setting={collectionCreatorPage.step2_collectionItemsSetting}
        open={$sortOrderModalShow}
        collectionItems={collectionCreatorPage.step2_resources}
        onChangeSetting={async (value) => {
          await onChange_needSaveDraft({
            step2_collectionItemsSetting: value,
          });
        }}
        onChangeSortSetting={async (sort) => {
          await dispatch<Step2_Fetch_CollectionItems_Action>({
            type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
          });
        }}
        onClickSortBy={async (sort: 'added' | 'title' | 'updateDate') => {
          const { ret, errCode, msg, data } =
            await FServiceAPI.Resource.reorderCollectionItems_Draft({
              resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
              sortField:
                sort === 'added'
                  ? 'createDate'
                  : sort === 'title'
                  ? 'itemTitle'
                  : 'resourceUpdateDate',
              sortType: sort === 'added' ? -1 : sort === 'title' ? 1 : -1,
            });
          if (ret !== 0 || errCode !== 0) {
            fMessage(msg, 'error');
            return;
          }
          await dispatch<Step2_Fetch_CollectionItems_Action>({
            type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
          });
        }}
        onChangeItemsSortID={async (itemIDs: string[], sortID: number) => {
          const { ret, errCode, msg, data } =
            await FServiceAPI.Resource.setCollectionItemsSortID_Draft({
              resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
              data: {
                itemIds: itemIDs,
                targetSortId: sortID,
              },
            });

          if (ret !== 0 || errCode !== 0) {
            fMessage(msg, 'error');
            return;
          }
          set$checkedItemIDs([]);

          await dispatch<Step2_Fetch_CollectionItems_Action>({
            type: 'collectionCreatorPage/step2_Fetch_CollectionItems',
          });
          await onChange_needSaveDraft_collectionItems({});
        }}
        pageSize={collectionCreatorPage.step2_resources_pageSize}
        pageCurrent={collectionCreatorPage.step2_resources_pageCurrent}
        totalCount={collectionCreatorPage.step2_resources_totalCount}
        onChangePage={onChangePage}
        onCancel={() => {
          set$sortOrderModalShow(false);
        }}
      />
    </div>
  );
}

export default connect(({ collectionCreatorPage }: ConnectState) => ({
  collectionCreatorPage: collectionCreatorPage,
}))(Step2);

interface SaveInputAttrs_ParamsType {
  resourceID: string;
  systemProperties: CollectionCreatorPageModelState['step2_systemProperties'];
  // customProperties: CollectionCreatorPageModelState['step2_customProperties'];
  // customConfigurations: CollectionCreatorPageModelState['step2_customConfigurations'];
}

export async function saveInputAttrs({ resourceID, systemProperties }: SaveInputAttrs_ParamsType) {
  const { data: data_result } = await FServiceAPI.Resource.updateCollection({
    resourceId: resourceID,
    inputAttrs: systemProperties
      .filter((sp) => sp.type === 'additional')
      .map((sp) => {
        return {
          key: sp.key,
          value: sp.value,
        };
      }),
    authExcludedItems: [],
  });
}

interface SaveCustomPropertyDescriptors_ParamsType {
  resourceID: string;
  customProperties: CollectionCreatorPageModelState['step2_customProperties'];
  customConfigurations: CollectionCreatorPageModelState['step2_customConfigurations'];
}

export async function saveCustomPropertyDescriptors({
  resourceID,
  customProperties,
  customConfigurations,
}: SaveCustomPropertyDescriptors_ParamsType) {
  const { data: data_result } = await FServiceAPI.Resource.updateCollection({
    resourceId: resourceID,
    customPropertyDescriptors: [
      ...customProperties.map((i) => {
        return {
          type: 'readonlyText',
          key: i.key,
          name: i.name,
          remark: i.description,
          defaultValue: i.value,
        };
      }),
      ...customConfigurations.map((i) => {
        const isInput: boolean = i.type === 'input';
        const options: string[] = i.select;
        return {
          type: isInput ? 'editableText' : 'select',
          key: i.key,
          name: i.name,
          remark: i.description,
          defaultValue: isInput ? i.input : options[0],
          // defaultValue: isInput ? i.input : '',
          candidateItems: isInput ? undefined : options,
        };
      }),
    ],
    authExcludedItems: [],
  });
}
